import React from 'react';
import { FileText } from 'lucide-react';
import type { ListDocumentsWidgetData } from '../../../types/agentWidgets';
import { useDocumentViewer } from '../../../contexts/DocumentViewerContext';

interface Props {
  data: ListDocumentsWidgetData;
}

export const ListDocumentsWidget: React.FC<Props> = ({ data }) => {
  const { openDocument } = useDocumentViewer();

  if (data.documents.length === 0) return null;

  return (
    <div className="mt-1.5 space-y-1">
      <p className="text-[10px] uppercase tracking-wide text-gray-400 dark:text-gray-500 font-medium">
        {data.totalCount} document{data.totalCount !== 1 ? 's' : ''}
      </p>
      <div className="space-y-1">
        {data.documents.map((doc) => (
          <div
            key={doc.id}
            className="flex items-center gap-2 text-[11px] bg-indigo-50/70 dark:bg-indigo-900/10 rounded px-2 py-1.5 group"
          >
            <FileText className="h-3 w-3 text-indigo-500 dark:text-indigo-400 flex-shrink-0" />
            <span className="font-medium text-indigo-700 dark:text-indigo-300 truncate flex-1 min-w-0">
              {doc.name}
            </span>
            <span className="text-[10px] text-gray-400 dark:text-gray-500 whitespace-nowrap">
              {doc.documentType.replace(/_/g, ' ').toLowerCase()}
            </span>
            {doc.pageCount != null && (
              <span className="text-[10px] text-gray-400 dark:text-gray-500 whitespace-nowrap">
                {doc.pageCount}p
              </span>
            )}
            <button
              onClick={() =>
                openDocument({
                  documentId: doc.id,
                  documentName: doc.name,
                })
              }
              className="text-indigo-600 dark:text-indigo-400 hover:underline whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity text-[10px] font-medium"
            >
              Open
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
